if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

    if (theme.settings.afterAtc !== "no-js") {
      // Add binding for the submit event
      this.addEventListener("submit", this.handleSubmit.bind(this));

      // Add event listener for the 'change' event with handleQuantityChange
      this.form.addEventListener("change", (evt) => {
          evt.stopPropagation();
          this.handleQuantityChange(evt);
      });

    }
  }
}

    // Function to handle quantity changes
    async handleQuantityChange(evt) {
    const quantityInput = evt.target;
    const collectionDataInput = quantityInput.closest('form').querySelector('input[name="CollectionData"]');
    let parentCat = '';
    let childCat = '';
    
    if (collectionDataInput) {
          parentCat = collectionDataInput.getAttribute('data-parenCategory');
          childCat = collectionDataInput.getAttribute('data-childCategory');
    }
   
    const variantId = parseInt(quantityInput.dataset.variantId, 10);
    console.log("trigger");
    if (!variantId) {
      console.error('Variant ID not found.');
      return;
    }
  const productTags = collectionDataInput 
  ? collectionDataInput.dataset.tags.split(',').map(tag => tag.trim()) 
  : [];    
    console.log('productTags:', productTags);
    const newQuantity = parseInt(quantityInput.value, 10);    
    // Default limit if no maxqty_ tag is found
    let quantityLimit = 4;    
    // Find the tag that starts with maxqty_
    const maxQtyTag = productTags.find(tag => tag.startsWith("maxqty_"));    
    if (maxQtyTag) {
      const limit = parseInt(maxQtyTag.replace("maxqty_", ""), 10);
      if (!isNaN(limit)) {
        quantityLimit = limit; // Set quantity limit to the number extracted
      }
    }
    if (newQuantity > quantityLimit) {
      alert(`You can only add up to ${quantityLimit} of the same item.`);
      quantityInput.value = quantityLimit; // Reset the quantity to the limit
      return; // Stop further processing
    }

    try {
      // Prepare formData for the cart update request
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', newQuantity);
  
      // Include sections data in the formData
      let sections = "cart-icon-bubble";
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest(".shopify-section").id.replace("shopify-section-", "")}`;
      }
      formData.append("sections", sections);
  
      // Make the cart update request
      const changeResponse = await fetch(`${theme.routes.cartChange}`, {
        method: 'POST',
        headers: {
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });
  
      if (!changeResponse.ok) throw new Error(changeResponse.statusText);
      const updatedCartData = await changeResponse.json();

      // Check if the newQuantity is zero AFTER the cart update
        if (newQuantity === 0) {
            // Find the enclosing quantity-input element and hide it
            const quantityInputWrapper = quantityInput.closest('.qty-input');
            if (quantityInputWrapper) {
                quantityInputWrapper.style.display = 'none';
            }

            // Display the primary cart button
            const productForm = quantityInput.closest('product-form');
            if (productForm) {
                const primaryCartButton = productForm.querySelector('.btn--primary');
                if (primaryCartButton) {
                    primaryCartButton.style.display = 'block';
                }
            }
        }

      // Update cart UI based on the updated cart data
      ProductForm.updateCartIcon(updatedCartData);
      // console.log('updatedCartData', updatedCartData);
       if (newQuantity > 1) {
            // Check if the variantId matches any item in the updatedCartData
            const matchingItem = updatedCartData.items.find(item => item.variant_id === variantId);
        
            if (matchingItem) {
                 const eventData = createSmartechEventData(matchingItem, parentCat, childCat);
                 smartech('dispatch', 'add to cart custom', eventData);
                 createGAEventData(matchingItem, parentCat, childCat);
        }
        }
 
      // Additional UI updates as needed
       const quickAddDrawer = this.closest("quick-add-drawer");
          if (quickAddDrawer) quickAddDrawer.addedToCart();
  
          if (this.cartDrawer) {
            this.cartDrawer.renderContents(
              updatedCartData,
              !quickAddDrawer && theme.settings.afterAtc === "drawer"
            );
          } else if (window.location.pathname === theme.routes.cart) {
            const cartItems = document.querySelector("cart-items");
            if (cartItems) {
              if (cartItems.dataset.empty === "true") {
                window.location.reload();
              } else {
                cartItems.refreshCart();
              }
            }
          }
      this.dispatchEvent(
        new CustomEvent("on:line-item:change", {
          bubbles: true,
          detail: {
            variantId: variantId,
            newQuantity: newQuantity,
          },
        })
      );
  
    } catch (error) {
      console.error('Error updating quantity:', error);
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
  if (evt.target.id === "product-signup_form") return;

      evt.preventDefault();

  if (this.submitBtn.getAttribute("aria-disabled") === "true") return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
  this.submitBtn.setAttribute("aria-disabled", "true");
  this.submitBtn.classList.add("is-loading");

  // Find the hidden input field with the name 'CollectionData'
  const collectionDataInputSubmit = evt.target.querySelector('input[name="CollectionData"]');
  let parentCat = '';
  let childCat = '';
  let productTags = [];

  if (collectionDataInputSubmit) {
    parentCat = collectionDataInputSubmit.getAttribute('data-parencategory');
    childCat = collectionDataInputSubmit.getAttribute('data-childcategory');
     productTags =  collectionDataInputSubmit 
    ? collectionDataInputSubmit.getAttribute('data-tags').split(',').map(tag => tag.trim()) 
    : [];
  }
      const formData = new FormData(this.form);
  const variantId = parseInt(formData.get('id'));

  let sections = "cart-icon-bubble";
      if (this.cartDrawer) {
    sections += `,${this.cartDrawer.closest(".shopify-section").id.replace("shopify-section-", "")}`;
      }
  formData.append("sections_url", window.location.pathname);
  formData.append("sections", sections);

      const fetchRequestOpts = {
    method: "POST",
        headers: {
      Accept: "application/javascript",
      "X-Requested-With": "XMLHttpRequest",
        },
    body: formData,
      };

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

    const itemInOldCartCheck = oldCartData.items.find(
      (item) => item.variant_id === variantId
    );

    console.log('productTagsvv:', productTags);
    // Default limit if no maxqty_ tag is found
    let quantityLimit = 4;    
    // Find the tag that starts with maxqty_
    const maxQtyTag = productTags.find(tag => tag.startsWith("maxqty_"));    
    if (maxQtyTag) {
      const limit = parseInt(maxQtyTag.replace("maxqty_", ""), 10);
      if (!isNaN(limit)) {
        quantityLimit = limit; // Set quantity limit to the number extracted
      }
    }
    if (itemInOldCartCheck && (itemInOldCartCheck.quantity) >= quantityLimit) {
      alert(`You can only add up to ${quantityLimit} of the same item.`);
      this.submitBtn.classList.remove("is-loading");
      this.submitBtn.removeAttribute("aria-disabled");
      return;
    }

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();

    var eventData = createSmartechEventData(data, parentCat, childCat);
    smartech('dispatch', 'add to cart custom', eventData);
    createGAEventData(data, parentCat, childCat);
    
    const error = typeof data.description === "string" ? data.description : data.message;

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

    if (theme.settings.afterAtc === "page") {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
    }
    else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
      const quickAddDrawer = this.closest("quick-add-drawer");
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
            !quickAddDrawer && theme.settings.afterAtc === "drawer"
              );
            } else if (window.location.pathname === theme.routes.cart) {
          const cartItems = document.querySelector("cart-items");
              if (cartItems) {
            if (cartItems.dataset.empty === "true") {
                  window.location.reload();
                } else {
              cartItems.refreshCart();
                }
              }
            }
          }, 700);
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
    const itemInOldCart = oldCartData.items.find(
          (item) => item.variant_id === data.variant_id
    );

        // Check if product was already in the cart
        if (itemInOldCart) {
      this.dispatchEvent(
        new CustomEvent("on:line-item:change", {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
            newQuantity:
              itemInOldCart.quantity === data.quantity
                ? itemInOldCart.quantity
                : data.quantity,
          },
        })
      );
        } else {
    if (data.variant_id == 41091533930556) {
        document.querySelector('.product-info__add-button').style.display = 'none';
      }
      this.dispatchEvent(
        new CustomEvent("on:cart:add", {
            bubbles: true,
            detail: {
              cart: newCartData,
            variantId: data.variant_id,
          },
        })
      );
      // Check if a div for the quantity input already exists for the selected variant.
      let quantityDiv = this.querySelector(
        '.qty-input[data-variant-id="' + data.variant_id + '"]'
      );

      if (!quantityDiv) {
        // If the div doesn't exist, create a new one.
        const newQuantityDiv = document.createElement("quantity-input");
        newQuantityDiv.innerHTML =
          '<div class="qty-input inline-flex items-center w-full variant appending_here" data-variant-id="' +
          data.variant_id +
          '">' +
          '<button type="button" class="qty-input__btn btn btn--minus no-js-hidden" name="minus">' +
          '<span class="visually-hidden">-</span>' +
          "</button>" +
          '<input max="' + (maxQtyTag ? quantityLimit : 4) + '" type="number" class="qty-input__input input" id="quantity-' +
          data.variant_id +
          '" name="updates[]" min="0" value='+data.quantity +' data-index="1" data-initial-value='+data.quantity +' aria-label="Quantity" data-variant-id='+data.variant_id+'>' +
          '<button type="button" class="qty-input__btn btn btn--plus no-js-hidden" name="plus">' +
          '<span class="visually-hidden">+</span>' +
          "</button>" +
          "</div>";

        // Append the new div to the form.
        let button = this.querySelector('.btn--primary');
        if (button) {
          button.insertAdjacentElement('afterend', newQuantityDiv);
        }
        if (newQuantityDiv) {
console.log('fssssssssssssssssssssssssssssssssssssssssssss');
          // Add event listener for the 'change' event with handleQuantityChange
          this.form.addEventListener("change", (evt) => {
            evt.stopPropagation();
            this.handleQuantityChange.bind(this)
          });
        }
      }
      else {
        const inputField = quantityDiv.querySelector('.qty-input__input');
        if (inputField) {
          inputField.value = data.quantity;
        }            
      }

      // Hide the "Add to Cart" button when the quantity div is created.
      const addToCartButton = this.querySelector('.btn--primary');
      if (addToCartButton) {
        addToCartButton.style.display = "none";
      }
      // Show the div for the quantity input.
      if (quantityDiv) { quantityDiv.style.display = "block"; }
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
    this.dispatchEvent(
      new CustomEvent("on:cart:error", {
          bubbles: true,
          detail: {
          error: this.errorMsg.textContent,
        },
      })
    );
      } finally {
        // Re-enable 'Add to Cart' button.
    this.submitBtn.classList.add("is-success");
    this.submitBtn.removeAttribute("aria-disabled");
        setTimeout(() => {
      this.submitBtn.classList.remove("is-loading");
      this.submitBtn.classList.remove("is-success");
        }, 1400);
      }
    }





    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById("cart-icon-bubble");
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections["cart-icon-bubble"];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector(".js-form-error");
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) this.errorMsg.textContent = error;
    }
  }

  function createSmartechEventData(productData, parentcategory, subcategory) {
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
      var eventData = {
          'prid': parseInt(productData.product_id, 10),
          'name': productData.product_title,
          'brand': productData.vendor,
          'activity_date': formattedDate,
          'variant': productData.variant_title,
          'prqt': 1,
          'price': parseFloat(productData.price/100),
          'currency': 'INR',
          'image': productData.image,
          'produrl': 'https://plumgoodness.com/products/'+productData.handle,
          'refrer url': 'https://plumgoodness.com/products/'+productData.handle,
          'producttype': productData.product_type,
          'pagetype': window.location.href,
          'category': parentcategory,
          'subcategory': subcategory
      };
  
      return eventData;
  }
  function createGAEventData(productData, parentcategory, subcategory) {
    dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "GA4_add_to_cart",
          ecommerce: {
            items: [
              {
                  'item_id': parseInt(productData.product_id, 10),
                  'item_name': productData.product_title,
                  'item_brand': productData.vendor,
                  'item_variant': productData.variant_title,
                  'quantity': 1,
                  'price': parseFloat(productData.price/100),
                  'currency': 'INR',
                  'image': productData.image,
                  'item_category': parentcategory,
                  'item_category2': subcategory
              }] 
      }
         });
  }

  customElements.define("product-form", ProductForm);
}
